import { SignalsService } from "@/services";
import { SignalDetail, SignalNotificationsType, Signals, SignalType } from "@/services/DTOs";
import { ActionContext, Module } from "vuex";

interface ISignalUpdate {
  personId: string;
  organizationId: number;
  type?: SignalType;
  notificationsType?: SignalNotificationsType;
}

let initialized = false;
const emptySignals = {
  signalers: [],
  signaled: []
};

class SignalsState {
  public signals: Signals;
  public ready: boolean;

  constructor(signals: Signals, ready: boolean) {
    this.signals = signals;
    this.ready = ready;
  }
}

export default {
  namespaced: true,
  state: (): SignalsState => ({
    ...new SignalsState(emptySignals, false)
  }),
  mutations: {
    ready(state: SignalsState, signals: Signals) {
      state.signals = signals;
      state.ready = true;
    },
    updateSignal(state: SignalsState, { personId, organizationId, type, notificationsType }: ISignalUpdate) {
      const existingSignalIndex = state.signals.signaled.findIndex(
        (signaled: SignalDetail) => personId
          ? signaled.personId === personId
          : signaled.organizationId === organizationId
      );

      if (existingSignalIndex !== -1) {
        if (type === SignalType.NoSignal) {
          state.signals.signaled.splice(existingSignalIndex, 1);
        } else {
          state.signals.signaled[existingSignalIndex] = new SignalDetail({
            ...state.signals.signaled[existingSignalIndex],
            ...type && { type },
            ...notificationsType && { notificationsType }
          });
        }
      } else {
        state.signals.signaled = [
          ...state.signals.signaled,
          {
            personId,
            organizationId,
            type: type || SignalType.NoSignal,
            notificationsType: notificationsType || SignalNotificationsType.Relevant
          }
        ].map((s) => new SignalDetail(s));
      }
    }
  },
  actions: {
    getSignals(context: ActionContext<SignalsState, any>): void {
      if (initialized) {
        return;
      }
      initialized = true;
      const { authentication: { user } } = context.rootState.users;
      if (user && user.hasBio) {
        SignalsService.getSignals(user.username as string)
          .subscribe((signals) => {
            context.commit("ready", signals);
          }, () => {
            context.commit("ready", emptySignals);
          });
      } else {
        context.commit("ready", emptySignals);
      }
    }
  }
} as Module<SignalsState, any>;
